import { render, staticRenderFns } from "./sidenavbar.vue?vue&type=template&id=fd746dba&"
import script from "./sidenavbar.vue?vue&type=script&lang=js&"
export * from "./sidenavbar.vue?vue&type=script&lang=js&"
import style0 from "./sidenavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports